import React from "react";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import TeamMemberList from "../../components/TeamMemberList";

const OurTeam: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Our Team"></CardHeader>
          <CardContent>
            <TeamMemberList></TeamMemberList>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default OurTeam;
